<template>
  <v-app-bar class="app-bar" color="primary" dark>
    <!-- Stamen Project Archive -->

    <div id="bar-content" @click="handleClick">
      <img id="logo" :src="stamenHeader" />
      <span id="title-text">Internal Archive</span>
    </div>
  </v-app-bar>
</template>

<script>
// vuex
// library
// internal
import stamenHeader from '@/assets/img/stamenHeader.svg'
// components
export default {
  data() {
    return {
      stamenHeader
    }
  },
  methods: {
    handleClick() {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
.app-bar {
  position: relative;
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: flex-end;
  overflow: hidden;

  .v-toolbar__content {
    #logo {
      height: 45px;
    }

    #bar-content {
      cursor: pointer;
      width: 600px;
      transform: translateY(15px);
    }

    #title-text {
      font-size: 24px;
      font-weight: 300;
      margin-left: 10px;
    }
  }
}
</style>
